import React, { useState } from "react";
import { Outlet } from "react-router-dom";
interface ILayoutProps {
  className?: string;
}

const Layout = ({ className }: ILayoutProps) => {
  return (
    <>
      <div>
        <main>{<Outlet></Outlet>}</main>
      </div>
    </>
  );
};

export default Layout;
